export default "__VITE_ASSET__bfa3059d__"